import vertShader from './volume.vert.glsl';
import fragShader from './volume.frag.glsl';
import * as THREE from 'three';

var volumeShader = {
	uniforms: 
	{
		u_volume_scale: { value: new THREE.Vector3( 1, 1, 1 ) },
		u_volume_tex1: { value: null },
		u_volume_tex2: { value: null },
		u_volume_tex3: { value: null },
		// u_volume_tex: { value: [null, null, null] },
		u_show_vol: { value: [true, false, false] },
		// u_colormap: { value: null},
		u_volume_dims: { value: new THREE.Vector3( 1, 1, 1 ) },
		u_val_min: { value: 0 },
		u_val_max: { value: 1 },
		u_val_scale: { value: 0.3 },
		u_val_intensity: { value: 1 },
		u_cross_section: { value: false },
		u_dt_scale: { value: new THREE.Vector3( 1, 1, 1 ) },
	},
	vertexShader: vertShader,
	fragmentShader: fragShader
};

export default volumeShader;